import { baseApi } from "./api";
import type {
  AIChatHistoryResponse,
  AIChatSessionsResponse,
  AIChatUsageResponse,
} from "@nicsmith/shared_types";

export const aiChatApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get chat history for a module
    getAIChatMessages: builder.query<
      AIChatHistoryResponse,
      { moduleId: number; limit?: number }
    >({
      query: ({ moduleId, limit = 50 }) => ({
        url: `/ai/chat/${moduleId}/messages`,
        params: { limit },
      }),
      providesTags: (_result, _error, { moduleId }) => [
        { type: "AIChatMessages", id: moduleId },
      ],
    }),

    // List all AI chat sessions
    getAIChatSessions: builder.query<
      AIChatSessionsResponse,
      { limit?: number } | void
    >({
      query: (params) => ({
        url: "/ai/chat/sessions",
        params: { limit: params ? params.limit ?? 20 : 20 },
      }),
      providesTags: ["AIChatSessions"],
    }),

    // Get current month AI usage
    getAIChatUsage: builder.query<AIChatUsageResponse, void>({
      query: () => "/ai/chat/usage",
      providesTags: ["AIChatUsage"],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetAIChatMessagesQuery,
  useGetAIChatSessionsQuery,
  useGetAIChatUsageQuery,
} = aiChatApi;
